import _ from 'lodash'
import { createSelector } from 'reselect'

export const getUser = state => _.get(state, 'authentication.user', null)
export const getUserId = state => createSelector([getUser], user => user.userId)(state)



// WEBPACK FOOTER //
// ./src/selectors/auth.js